<app-fnf-base-dialog
  [visible]="visible()"
  [subject]="dialogProps().subject"
  class="w-[clamp(269px,80vw,402px)] min-h-[clamp(490px,80vw,585px)]"
  (onClose)="close()"
>
  <div class="fnf-dialog-warningicon">
    <svg viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="64" cy="64" r="64" fill="#E6E6E6" />
      <circle cx="64" cy="64" r="54.5" stroke="#A7A7A7" stroke-width="3" />
      <path
        d="M66.1363 76.47C66.1363 77.1109 65.8817 77.7256 65.4285 78.1788C64.9753 78.632 64.3606 78.8866 63.7196 78.8866C63.0787 78.8866 62.464 78.632 62.0108 78.1788C61.5576 77.7256 61.303 77.1109 61.303 76.47C61.303 75.829 61.5576 75.2143 62.0108 74.7611C62.464 74.3079 63.0787 74.0533 63.7196 74.0533C64.3606 74.0533 64.9753 74.3079 65.4285 74.7611C65.8817 75.2143 66.1363 75.829 66.1363 76.47ZM65.5321 56.5325C65.5321 56.0518 65.3412 55.5908 65.0013 55.2508C64.6614 54.9109 64.2004 54.72 63.7196 54.72C63.2389 54.72 62.7779 54.9109 62.438 55.2508C62.0981 55.5908 61.9071 56.0518 61.9071 56.5325V67.4075C61.9071 67.8882 62.0981 68.3492 62.438 68.6891C62.7779 69.029 63.2389 69.22 63.7196 69.22C64.2004 69.22 64.6614 69.029 65.0013 68.6891C65.3412 68.3492 65.5321 67.8882 65.5321 67.4075V56.5325Z"
        fill="#A7A7A7"
      />
      <path
        d="M58.49 42.0178C60.8172 37.9941 66.622 37.9941 68.9493 42.0178L90.6195 79.4858C92.9468 83.5144 90.0395 88.5531 85.3875 88.5531H42.0518C37.3973 88.5531 34.4925 83.5144 36.8197 79.4858L58.49 42.0178ZM65.8125 43.8327C65.5994 43.4666 65.2939 43.1628 64.9267 42.9516C64.5595 42.7404 64.1432 42.6293 63.7196 42.6293C63.296 42.6293 62.8798 42.7404 62.5125 42.9516C62.1453 43.1628 61.8399 43.4666 61.6268 43.8327L39.959 81.3007C39.7478 81.6684 39.6369 82.0851 39.6373 82.5091C39.6377 82.9331 39.7495 83.3495 39.9614 83.7168C40.1733 84.084 40.4779 84.3892 40.8447 84.6018C41.2116 84.8144 41.6278 84.9269 42.0518 84.9281H85.3875C85.8111 84.9267 86.2269 84.8141 86.5934 84.6016C86.96 84.3892 87.2643 84.0843 87.4761 83.7174C87.688 83.3505 87.7998 82.9345 87.8005 82.5108C87.8013 82.0872 87.6908 81.6708 87.4803 81.3031L65.8125 43.8327Z"
        fill="#A7A7A7"
      />
    </svg>
  </div>

  <!-- Título -->
  <h2 class="fnf-dialog-title text-center" [innerHTML]="getFormattedText('title')"></h2>

  <!-- Descripción opcional -->
  @if (dialogProps().description) {
  <p class="fnf-dialog-subtitle text-center" [innerHTML]="getFormattedText('description')"></p>
  } @if (dialogProps().error) {
  <div class="error-container w-full">
    <span>{{ dialogProps().error }}</span>
  </div>
  }

  <!-- Botones de acción -->
  <div class="fnf-dialog-buttons-container">
    <app-fnf-buttons
      [buttonProps]="{
        isLoading: dialogProps().isLoading,
        isDisabled: dialogProps().isLoading,
        text: dialogProps().buttonText,
        variant: 'primary',
        class: 'min-w-[218px]',
      }"
      (onClick)="action()"
    />
    <app-fnf-buttons
      [buttonProps]="{
        isDisabled: dialogProps().isLoading,
        text: 'Cancelar',
        variant: 'outline',
        class: 'min-w-[218px]',
      }"
      (onClick)="close()"
    />
  </div>
</app-fnf-base-dialog>
